export const SOURCES = [
  { value: 'linkedin', label: 'LinkedIn', color: '#0A66C2' },
  { value: 'instagram', label: 'Instagram', color: '#E1306C' },
  { value: 'facebook', label: 'Facebook', color: '#1877F2' },
  { value: 'twitter', label: 'Twitter / X', color: '#1DA1F2' },
  { value: 'article', label: 'Article / Publication', color: '#8B5CF6' },
  { value: 'referral', label: 'Referral / Friend', color: '#10B981' },
  { value: 'podcast', label: 'Guest of another podcast', color: '#F59E0B' },
  { value: 'newsletter', label: 'Newsletter', color: '#EC4899' },
  { value: 'conference', label: 'Conference / Event', color: '#06B6D4' },
  { value: 'other', label: 'Other', color: '#64748B' }
];

export const PROSPECT_LABELS = [
  { value: 'podcast_guest', label: 'Podcast Guest', color: '#A78BFA' },
  { value: 'app_user', label: 'App User', color: '#0EA5E9' }
];

export const PROSPECT_STATUSES = [
  { value: 'new', label: 'New', color: '#94A3B8' },
  { value: 'contacted', label: 'Contacted', color: '#3B82F6' },
  { value: 'replied', label: 'Replied', color: '#8B5CF6' },
  { value: 'booked', label: 'Booked ✓', color: '#10B981' },
  { value: 'declined', label: 'Declined', color: '#EF4444' },
  { value: 'archived', label: 'Archived', color: '#64748B' }
];
